import React from 'react'
import { FaqAccordionElement } from '@shared/components/sections/faq/model'

export const loansFaq: FaqAccordionElement[] = [
	{
		title: 'Возможно ли получить заём, если были просрочки и плохая кредитная история?',
		content: (
			<div>
				<p>
					Мы лояльно относимся к кредитной истории. Если у клиента когда-то были просрочки, это вряд
					ли станет стоп-фактором при рассмотрении заявки. Мы изучаем множество показателей и
					составляем совокупный отчёт, по которому выносим решение.
				</p>
				<br />
				<p>
					Наша тактика рассмотрения заявок отличается от банковской: стараемся находить
					индивидуальный подход к каждому клиенту. Иногда можем глубже проанализировать ситуацию или
					выйти на переговоры, чтобы уточнить детали.
				</p>
				<br />
				<p>Подробности можете почитать в журнале про кредиты «Процент»:</p>
				<ol>
					<li>
						<a
							href='https://journal.credit.club/kak-uluchshit-kreditnuyu-istoriyu-6-sposobov'
							className='main-link'
							target='_blank'
							rel='noopener noreferrer nofollow'
						>
							Как улучшить кредитную историю: 6 способов
						</a>
					</li>
					<li>
						<a
							href='https://journal.credit.club/kak-ispravit-plohuyu-kreditnuyu-istoriyu'
							className='main-link'
							target='_blank'
							rel='noopener noreferrer nofollow'
						>
							Как исправить плохую кредитную историю
						</a>
					</li>
					<li>
						<a
							href='https://journal.credit.club/kak-ispravit-oshibki-v-kreditnoj-istorii'
							className='main-link'
							target='_blank'
							rel='noopener noreferrer nofollow'
						>
							Как исправить ошибки в кредитной истории
						</a>
					</li>
				</ol>
				<br />
				<iframe
					width='100%'
					height='515'
					src='https://www.youtube.com/embed/RGu-5joZuCo'
					title='YouTube video player'
					frameBorder='0'
					allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
					allowFullScreen
				></iframe>
			</div>
		),
	},
	{
		title:
			'Квартира остаётся в собственности залогодателя. Что с ней происходит после получения займа?',
		content: (
			<div>
				<p>
					Мы работаем в соответствии с законом{' '}
					<a
						href='https://www.consultant.ru/document/cons_doc_LAW_19396/'
						className='main-link'
						target='_blank'
						rel='noopener noreferrer nofollow'
					>
						102-ФЗ «Об ипотеке».{' '}
					</a>
					Поэтому после оформления сделки на недвижимость накладывается обременение. Квартира
					остаётся в собственности заёмщика. Он может делать ремонт, приглашать гостей или сдавать
					жильё в аренду. При этом ограничения действуют на продажу, обмен и дарение квартиры без
					согласия кредитора.
				</p>
				<br />
				<p>
					Подчеркнём: мы не переоформляем квартиры на третьих лиц, не выкупаем их и не выписываем
					владельцев. <b>Заёмщик остаётся владельцем недвижимости</b>.
				</p>
				<br />
				<p>
					Подробности можете прочитать в журнале «Процент»:{' '}
					<a
						href='https://journal.credit.club/kvartira-v-zaloge'
						className='main-link'
						target='_blank'
						rel='noopener noreferrer nofollow'
					>
						Квартира в залоге. Что с ней теперь будет?
					</a>
				</p>
				<br />
				<iframe
					width='100%'
					height='515'
					src='https://www.youtube.com/embed/4pcGBf33yuw'
					title='YouTube video player'
					frameBorder='0'
					allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
					allowFullScreen
				></iframe>
			</div>
		),
	},
	{
		title: 'Нет квартиры в собственности для залога. Что делать, если нужны деньги?',
		content: (
			<div>
				<p>
					Для получения займа залогодателем в сделке не обязательно должен быть заёмщик. Им может
					стать кто угодно: друг, родственник, партнёр по бизнесу.
				</p>
				<br />
				<p>
					Поэтому если вы уверены в своём доходе и у вас есть человек, который вам доверяет, можете
					обратиться к нему за помощью. Вот какие аргументы можно использовать:
				</p>
				<br />
				<ul>
					<li>- квартира останется в собственности человека;</li>
					<li>- на неё накладывается обременение, которое снимается после выплаты займа;</li>
					<li>
						- собственник сможет жить в своей квартире, приглашать друзей, делать ремонт или сдавать
						её студентам;
					</li>
					<li>
						{' '}
						- если сделка оформлена по закону, никто не сможет просто так забрать недвижимость.;
					</li>
				</ul>
			</div>
		),
	},
	{
		title: 'Сколько времени рассматриваете заявку?',
		content: (
			<p>
				Обычно заявка проверяется в течение получаса. В некоторых случаях может понадобиться больше
				времени — до 1–2 рабочих дней. Скорость рассмотрения зависит от многих факторов. К примеру,
				чем быстрее мы получаем документы от клиента, тем скорее берём в работу его заявку.
			</p>
		),
	},
	{
		title: 'Как проходит подписание документов?',
		content: (
			<div>
				<p>Подписание документов состоит из нескольких шагов.</p>
				<br />
				<ul style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
					<li>
						<b>Шаг 1.</b> Наш представитель приезжает на объект залога с полным пакетом документов
						для каждого участника сделки
					</li>
					<li>
						<b>Шаг 2.</b> Он фотографирует объект залога: делает снимки всех комнат.
					</li>
					<li>
						<b>Шаг 3.</b> Мы подписываем документы в печатном виде. Каждый участник сделки получает
						пакет документов на руки.
					</li>
					<li>
						<b>Шаг 4.</b> Мы выпускаем электронную подпись для заёмщика и залогодателя. Больше об
						электронной подписи можно почитать в журнале про кредиты «Процент»:{' '}
						<a
							href='https://journal.credit.club/chto-takoe-kvalifitsirovannaya-elektronnaya-podpis'
							className='main-link'
							target='_blank'
							rel='noopener noreferrer nofollow'
						>
							Что такое квалифицированная электронная подпись
						</a>
					</li>
					<li>
						<b>Шаг 5.</b> Участники сделки подписывают электронный пакет документов через личный
						кабинет и приложение myDSS.
					</li>
					<li>
						<b>Шаг 6.</b> Мы формируем электронное заявление на регистрацию обременения в Росреестр.
						Залогодатель подписывает его с помощью электронной подписи.
					</li>
				</ul>
				<p>
					Затем мы отправляем заявление в Росреестр. Для этого не нужно ехать в МФЦ — весь процесс
					проходит удалённо, потому что мы заключили соглашение с Росреестром и подключились к их
					системе.
				</p>
			</div>
		),
	},
	{
		title: 'Как быстро деньги придут на счёт?',
		content: (
			<div>
				<p>
					Чаще всего деньги поступают на счёт не позднее 1–2 рабочих дней после регистрации сделки в
					Росреестре.
				</p>
				<p>Сама регистрация обременения обычно занимает не больше 3-х дней.</p>
			</div>
		),
	},
	{
		title: 'Возможно ли частично-досрочное и полное погашение в любой момент?',
		content: (
			<div>
				<p>
					<b>Частично-досрочное погашение долга.</b> Производить можно раз в месяц. Для этого нужно
					запросить бланк заявления у менеджера, подписать его и отправить нам скан. Лучше всего
					оформлять документ за 2–3 рабочих дня до крайней даты платежа.
				</p>
				<br />
				<p>
					<b>Полное досрочное погашение займа.</b> Его можно сделать в любое время. Процесс простой:
				</p>
				<br />
				<ol type='1' style={{ paddingLeft: '20px' }}>
					<li style={{ listStyleType: 'inherit' }}>получить шаблон заявления у менеджера;</li>
					<li style={{ listStyleType: 'inherit' }}>
						подписать и отправить скан или фото документа;
					</li>
					<li style={{ listStyleType: 'inherit' }}>
						запросить расчётный счет для полного погашения займа у менеджера;
					</li>
					<li style={{ listStyleType: 'inherit' }}>внести деньги, чтобы погасить долг;</li>
				</ol>
			</div>
		),
	},
]
